import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isMoveListElementRequestFailure(): boolean {
      return getState().isFailure;
    },
    isMoveListElementRequestPending(): boolean {
      return getState().isPending;
    },
    isMoveListElementRequestSuccess(): boolean {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
